import assign from 'lodash/assign';
import constants from '../constants';
import sharedConfig from '../../sharedConfig';

const initState = () => ({
  hostname: null,
  brand: sharedConfig.defaultBrand,
  userAgent: '',
  isMobile: false,

  // SSR-specific fields for forwarding request context to backend APIs
  originalServerSideRequestCookies: '',
  ip: '',
});

const app = (state = initState(), action = {}) => {
  const { type, payload } = action;

  if (type === constants.UPDATE_APP) {
    return assign({}, state, payload);
  } else {
    return state;
  }
};

export default app;
